import { handleServiceRequest } from '../handle-service-request';

const getToggles = () => {
    const getObject = {
        url: '/api/System/Toggle',
    };
    return handleServiceRequest.get(getObject);
};
const postToggles = toggles => {
    const postObject = {
        url: '/api/System/Toggle',
        postBody: toggles,
    };
    return handleServiceRequest.post(postObject);
};

const getAdminSettings = () => {
    const getObject = {
        url: '/api/System/AdminSettings',
    };
    return handleServiceRequest.get(getObject);
};
const postAdminSettings = userInput => {
    const postObject = {
        url: '/api/System/AdminSettings',
        postBody: userInput,
    };
    return handleServiceRequest.post(postObject);
};

export const cheAdminSettingsService = {
    getToggles,
    postToggles,
    getAdminSettings,
    postAdminSettings,
};
